<template>
  <div v-if="value"
    class="tile is-parent"
    :class="{ 'box ml-2 mb-5': showBox }">
    <article class="tile is-child is-parent">
      <div class="columns mb-0">
        <div class="column is-flex is-align-items-center">
          <i class="icon mdi mdi-calendar mdi-24px" />
          <p class="modal-card-title pl-1">Booking</p>
        </div>
      </div>
      <div class="is-divider" />
      <div class="tile is-ancestor">
        <div class="tile">
          <div class="tile is-parent is-half">
            <article class="tile is-child">
              <div class="columns field">
                <div class="column">
                  <div class="field">
                    <label class="label">Booking Attended</label>
                  </div>
                  <div class="field">
                    <div class="pretty p-default p-round p-bigger p-smooth">
                      <input type="radio"
                        id="text"
                        value="true"
                        v-model="value.isArriveForInspection"
                        @change="handleIsArriveForInspection"
                        :disabled="isArriveForInspectionDisabled">
                      <div class="state p-primary-o">
                        <label>Yes</label>

                      </div>
                    </div>
                    <div class="pretty p-default p-round p-bigger p-smooth">
                      <input type="radio"
                        id="text"
                        value="false"
                        v-model="value.isArriveForInspection"
                        @change="handleIsArriveForInspection"
                        :disabled="isArriveForInspectionDisabled">
                      <div class="state p-primary-o">
                        <label>No</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="field">
                <label class="label">{{ value.isArriveForInspection != null && !value.isArriveForInspection ? "Re-Book":"" }} Inspection Booking Date</label>
                <!-- <label class="label">Inspection Booking Date</label> -->
                <v-date-picker v-model="innerBookingStartDateTime"
                  :is-dark="$theme.isDark"
                  ref="innerBookingStartDateTime"
                  mode="dateTime"
                  :minute-increment="30"
                  :masks="formats"
                  :attributes="attrs"
                  :locale="$userInfo.locale"
                  class="is-fullwidth"
                  :model-config="innerBookingStartDateTime ? {} : modelConfig"
                  :timezone="$filters.getIanaTimezone()"
                  :min-date="minDate">
                  <template v-slot="{ inputValue, inputEvents }">
                    <div class="field has-addons">
                      <div class="control is-expanded has-icons-left">
                        <input type="text"
                          class="input"
                          placeholder="Booking Date"
                          :value="inputValue"
                          v-on="inputEvents"
                          :disabled="isArriveForInspectionDisabled"
                          :class="{ 'is-danger': !$v.entity.bookingStartDateTime.required }"
                          readonly>
                        <span class="icon is-small is-left">
                          <i class="mdi mdi-calendar mdi-18px" />
                        </span>
                      </div>
                      <div class="control"
                        v-if="!isArriveForInspectionDisabled">
                        <a class="button tooltip"
                          data-tooltip="Reset dates"
                          :class="{ 'is-danger': !$v.entity.bookingStartDateTime.required }"
                          @click="clearStartDate('innerBookingStartDateTime')">
                          <span class="icon">
                            <i class="mdi mdi-close mdi-24px" />
                          </span>
                        </a>
                      </div>
                    </div>
                    <span class="help is-danger"
                      v-if="!$v.entity.bookingStartDateTime.required">Inspection Booking Date is required</span>
                  </template>
                </v-date-picker>
              </div>
              <div class="field">
                <label class="label">Customer Has Been Contacted</label>
                <div class="control">
                  <bulma-checkbox v-model="value.isCustomerContacted"
                    :disabled="isCustomerContactedDisabled"
                    ref="isCustomerContacted" />
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import { DateTimeFiltersMixin, NumberFiltersMixin } from '@/components/mixins/filters'
import { FocusInserted } from '@/components/directives'
import BulmaCheckbox from '../../../../components/BulmaCheckbox/BulmaCheckbox.vue'

export default {
  name: 'BookingExtra',
  inject: ['$vv'],
  components: {
    BulmaCheckbox
  },
  directives: {
    FocusInserted
  },
  mixins: [DateTimeFiltersMixin, NumberFiltersMixin],
  props: {
    value: null,
    isNew: Boolean,
    showBox: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'W',
        navMonths: 'MMM',
        input: ['L', 'DD-MM-YYYY', 'DD/MM/YYYY'],
        data: ['L', 'DD-MM-YYYY', 'DD/MM/YYYY'],
        dayPopover: 'L'
      },
      attrs: [
        {
          key: 'today',
          highlight: {
            backgroundColor: '#ff8080'
          },
          popover: {
            label: 'Today'
          },
          dates: new Date()
        }
      ],
      modelConfig: {},
      innerBookingStartDateTime: null,
      originalBookingStartDateTime: null,
      minDate: new Date(),
      isArriveForInspectionDisabled: false,
      isCustomerContactedDisabled: false
    }
  },
  computed: {
    $v() {
      return this.$vv || this.$v
    },
    isArriveForInspection() {
      const isArriveForInspection = (this.value && this.value.isArriveForInspection === 'true') || this.value.isArriveForInspection === true
      return isArriveForInspection
    }
    // isRepairBooked() {
    //   return this.innerValue.isRepairBooked
    // }
    // minDate() {
    //   const today = new Date()
    //   return today
    // }
  },
  watch: {
    value: {
      handler: function (newVal, oldVal) {
        this.$emit('input', newVal)
      },
      deep: true
    },
    innerBookingStartDateTime: {
      handler: function (newVal, oldVal) {
        this.value.bookingStartDateTime = newVal
        if (this.value.bookingStartDateTime != null && this.value.bookingStartDateTime !== '') {
          this.value.isInspectionBooked = true
        } else {
          this.value.isInspectionBooked = false
        }
      }
    }
  },
  created() {
    if (this.value) {
      this.originalBookingStartDateTime = this.value.bookingStartDateTime
      this.innerBookingStartDateTime = this.value.bookingStartDateTime
    }
  },
  mounted() {
    this.$v.detailGroup.$touch()
    this.isCustomerContactedDisabled = !!this.value.isCustomerContacted
    this.isArriveForInspectionDisabled = !!this.value.isArriveForInspection
  },
  methods: {
    clearInputs(inputs, value) {
      if (value === 'false' || value == false || value === '' || value == null) {
        inputs.forEach((input) => {
          const key = Object.keys(input)[0]
          if (this.value.hasOwnProperty(key)) {
            this.value[key] = input[key]
          } else {
            console.warn(`Key ${key} does not exist in value object`)
          }
        })
      }
    },
    // handleIsRepairBooked() {
    //   const inputs = [{ repairStartDate: '' }, { repairEndDate: '' }]
    //   this.clearInputs(inputs, this.value.isRepairBooked)
    //   this.value.isRepairBooked = this.value.isRepairBooked == 'true'
    // },
    clearStartDate(input) {
      const inputEle = this.$refs[input]
      if (inputEle) {
        this.innerBookingStartDateTime = null
      }
    },
    clear(input) {
      const inputEle = this.$refs[input]
      if (inputEle) {
        this.value[input] = ''
      }
    },
    handleIsArriveForInspection() {
      // const inputs = [{ isRepairBooked: null }, { repairStartDate: '' }, { repairEndDate: '' }]
      //this.clearInputs(this.value.IsArriveForInspection)
      this.value.isArriveForInspection = this.value.isArriveForInspection == 'true'
      if (!this.value.isArriveForInspection) {
        this.clearStartDate('innerBookingStartDateTime')
      } else {
        this.minDate = null
        this.innerBookingStartDateTime = this.originalBookingStartDateTime
        this.$nextTick(() => {
          this.minDate = new Date()
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.is-divider {
  margin: 0 0 1.2rem 0;
}
.desc-width {
  width: 50%;
}
article.tile.is-child > .columns .column i.icon {
  color: #1a5276;
}
.modal-card-title {
  color: #1a5276;
  font-weight: 600;
  line-height: 1.125;
}
div.tile.is-parent {
  min-height: calc(100vh - 18rem);
}
</style>
